import { gql } from '@apollo/client'

export const LEAD_CREATE = gql`
  mutation GuideLeadCreate($email: String!, $tag: String!) {
    leadCreate(email: $email, tag: $tag) {
      email
    }
  }
`
